import { useEffect, useState } from 'react';
import { hasClipboard, subscribe } from '../HubOptions/hubClipboard';

/** Reactive hook that tracks whether the hub clipboard has content */
export function useClipboardState(): boolean {
  const [has, setHas] = useState(hasClipboard);

  useEffect(() => {
    const unsubscribe = subscribe(() => setHas(hasClipboard()));
    return unsubscribe;
  }, []);

  return has;
}
